
export default {
  methods: {
    trackEvent(eventName, eventCategory, value = 1) {

      let eventParams = {
        'event-category': eventCategory,
        'value': value,
        'page-location': window.location.href
      }
      // console.log(eventName)
      // console.log(eventParams);

      if (typeof gtag === 'function') {
        gtag('event', eventName, eventParams);
      } else {
        console.warn('Tracking attempted before gtag.js is initialized');
      }
    },
    trackMetaPurchase(value, orderId = null, currency = 'PEN') {
      const amount = Number(value);
      if (!Number.isFinite(amount) || amount <= 0) return;

      if (typeof window.fbq !== 'function') {
        console.warn('Meta Pixel tracking attempted before fbq is initialized');
        return;
      }

      const payload = { value: amount, currency };
      if (orderId != null && orderId !== '') {
        payload.order_id = String(orderId);
      }

      if (orderId != null && orderId !== '') {
        window.fbq('track', 'Purchase', payload, { eventID: String(orderId) });
      } else {
        window.fbq('track', 'Purchase', payload);
      }
    }
  }
};
